angular.module('kareo.ui.shared.directives.percent', [])
.directive('kPercent', [
  '$filter', function idCurrencyInjectingFunction($filter) {
    function stripToNumber(num) {
      num = num || '';
      var number = parseFloat(num.replace(/[^0-9|^\.|^-]+/g, ''));
      if (isNaN(number)) {
        return undefined;
      }
      return number;
    }

    function formatToPercent(number) {
      if (isNaN(number)) {
        return undefined;
      }
      if (number < 0) {
        return '-' + $filter('number')(number * -1, 2) + '%';
      }
      return $filter('number')(number, 2) + '%';
    }

    return {
      require: 'ngModel', restrict: 'A', link(scope, element, attr, ctrl) {
        element.on('blur', () => {
          scope.$apply(() => {
            var viewValue = element.val();
            var number = stripToNumber(viewValue);
            var formatted = formatToPercent(number);
            if (ctrl.$viewValue !== formatted) {
              element.val(formatted);
              ctrl.$setViewValue(formatted);
            }
          });
        });
        function viewValueChange(viewValue) {
          var decimal = stripToNumber(viewValue);
          if (!isNaN(decimal)) {
            decimal /= 100.0;
          }
          ctrl.$setValidity('validPercent', !isNaN(decimal));
          return decimal;
        }

        function modelChange(val) {
          ctrl.$setValidity('validPercent', !isNaN(val));
          return formatToPercent(val * 100.0);
        }

        ctrl.$parsers.push(viewValueChange);
        ctrl.$formatters.unshift(modelChange);
      }
    };
  }]);
